import { ComponentProps, useCallback, useEffect, useState } from "react";
import { useI18n } from "i18n";
import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import copy from "copy-to-clipboard";
import { useStyles } from "./WebviewWarningStyles";
import image from "./assets/outdated.svg";
import { BrowserLinks } from "./BrowserLinks";

interface ICopyButton {
  textToCopy: string;
  buttonText: string;
  successText: string;
}

const CopyButton = (props: ICopyButton & ComponentProps<typeof Button>) => {
  const { textToCopy, successText, buttonText, ...rest } = props;
  const [open, setOpen] = useState(false);

  const onClickCopy = useCallback(() => {
    copy(textToCopy);
    setOpen(true);
  }, [textToCopy]);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setOpen(false);
      }, 1000);
    }
  }, [open]);

  return (
    <Tooltip title={successText} open={open}>
      <Button onClick={onClickCopy} {...rest}>
        {buttonText}
      </Button>
    </Tooltip>
  );
};

interface IWebviewWarningProps {
  app: string;
}

const WebviewWarning = (props: IWebviewWarningProps) => {
  const { app } = props;
  const { t } = useI18n(["compatibility"]);
  const styles = useStyles();

  return (
    <Container className={styles.root}>
      <img className={styles.mainImage} src={image} alt="" />
      <Typography className={styles.text}>
        {t("compatibility:device.webview.message", { app })}
      </Typography>
      <CopyButton
        buttonText={t("compatibility:copy.link")}
        successText={t("compatibility:link.copied")}
        textToCopy={window.location.toString()}
        className={styles.button}
        color="blue"
        variant="primary"
      />
      <BrowserLinks className={styles.browserLinks} />
    </Container>
  );
};

export default WebviewWarning;
